<div class="ds admin-perms">
	<div class="wrap">
		<div class="op-head adm-head">
			<button type="button" class="back" routerLink="/admin" [attr.aria-label]="'common.back' | translate"><mat-icon>arrow_back</mat-icon></button>
			<div>
				<p class="eyebrow">{{ "header.menu.admin" | translate }}</p>
				<h1>{{ "admin.home.permisos.title" | translate }}</h1>
				<p class="opx-sub">{{ "admin.home.permisos.desc" | translate }}</p>
			</div>
		</div>

		<div class="container-fluid">
			<!-- Paso 1: seleccionar usuario -->
			<section class="step-card">
				<header class="step-head">
					<span class="step-num">1</span>
					<div class="step-text">
						<h2 class="step-title">{{ "admin.step1.title" | translate }}</h2>
						<p class="step-sub">{{ "admin.step1.sub" | translate }}</p>
					</div>

					<!-- Herramientas del usuario seleccionado (en el encabezado) -->
					<div class="user-tools" *ngIf="admin">
						<span class="dirty-dot" *ngIf="isDirty" [matTooltip]="'admin.unsaved.hint' | translate"></span>
						<ng-container *ngIf="!isEditMode">
							<button class="btn btn-ghost btn-sm" (click)="exportToExcel($event, admin?.usuarioId)">
								<span class="ic"><mat-icon [inline]="true">summarize</mat-icon></span>
								{{ "admin.summary" | translate }}
							</button>
							<button class="btn btn-primary btn-sm" (click)="enterEdit()">
								<span class="ic"><mat-icon [inline]="true">edit</mat-icon></span>
								{{ "common.edit" | translate }}
							</button>
						</ng-container>
						<ng-container *ngIf="isEditMode">
							<button class="btn btn-ghost btn-sm" (click)="cancelEdit()">
								<span class="ic"><mat-icon [inline]="true">close</mat-icon></span>
								{{ "common.cancel" | translate }}
							</button>
							<button class="btn btn-primary btn-sm" (click)="applyChanges()">
								<span class="ic"><mat-icon [inline]="true">save</mat-icon></span>
								{{ "admin.apply" | translate }}
							</button>
						</ng-container>
					</div>
				</header>
				<div class="user-row">
					<img
						*ngIf="selectedUser"
						[src]="photo"
						class="profile-image"
						alt=""
					/>
					<app-user-search
						class="user-search-field"
						[users]="userList"
						[label]="'admin.userSearch.label' | translate"
						[placeholder]="'admin.userSearch.placeholder' | translate"
						(userSelected)="onUserSelected($event)"
					></app-user-search>
				</div>
			</section>

			<div *ngIf="admin">
				<!-- Paso 2: perfiles -->
				<section class="step-card">
					<header class="step-head">
						<span class="step-num">2</span>
						<div class="step-text">
							<h2 class="step-title">{{ "admin.step2.title" | translate }}</h2>
							<p class="step-sub">{{ "admin.step2.sub" | translate }}</p>
						</div>
					</header>

					<div class="step2-controls">
						<ng-container *ngIf="!isEditMode">
							<div class="perfiles-chips" *ngIf="userPerfiles.length > 0">
								<span class="chip" *ngFor="let p of userPerfiles">{{ p.descripcion }}</span>
							</div>
							<div class="perfiles-empty" *ngIf="userPerfiles.length === 0">
								<mat-icon>badge</mat-icon>
								<span>{{ "roles.assign.none" | translate }}</span>
							</div>
						</ng-container>
						<!-- Edición: chips toggleables (sustituye al mat-select multiple; espejo de los chips de lectura). -->
						<div class="perfiles-chips perfiles-edit" *ngIf="isEditMode">
							<button
								type="button"
								class="chip chip-toggle"
								*ngFor="let p of perfilesCatalogo"
								[class.on]="isPerfilSelected(p.id)"
								(click)="togglePerfil(p.id)"
							>
								<mat-icon [inline]="true">{{ isPerfilSelected(p.id) ? "check" : "add" }}</mat-icon>
								{{ p.descripcion }}
							</button>
						</div>

					</div>
				</section>

				<!-- Paso 3: permisos por dimensión -->
				<section class="step-card">
					<header class="step-head">
						<span class="step-num">3</span>
						<div class="step-text">
							<h2 class="step-title">{{ "admin.step3.title" | translate }}</h2>
							<p class="step-sub">{{ "admin.step3.sub" | translate }}</p>
						</div>
					</header>

					<div class="perm-tabs">
						<button
							type="button"
							class="perm-tab"
							[class.active]="activeTab === 0"
							(click)="activeTab = 0"
						>
							{{ "admin.adminActivityTitle" | translate }}
							<span class="tab-badge" *ngIf="countActividad > 0">{{ countActividad }}</span>
						</button>
						<button
							type="button"
							class="perm-tab"
							[class.active]="activeTab === 1"
							(click)="activeTab = 1"
						>
							{{ "admin.adminContratoTitle" | translate }}
							<span class="tab-badge" *ngIf="countContrato > 0">{{ countContrato }}</span>
						</button>
						<button
							type="button"
							class="perm-tab"
							[class.active]="activeTab === 2"
							(click)="activeTab = 2"
						>
							{{ "admin.adminZoneTitle" | translate }}
							<span class="tab-badge" *ngIf="countZona > 0">{{ countZona }}</span>
						</button>
						<button
							type="button"
							class="perm-tab"
							[class.active]="activeTab === 3"
							(click)="activeTab = 3"
						>
							{{ "admin.adminCenterTitle" | translate }}
							<span class="tab-badge" *ngIf="countCentro > 0">{{ countCentro }}</span>
						</button>
					</div>

					<!-- Línea de Negocio (actividad) -->
					<div class="perm-panel" [hidden]="activeTab !== 0">
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsAc">
								<ng-container matColumnDef="filtro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell" [attr.colspan]="4">
										<input type="text" [placeholder]="'admin.filter' | translate" class="dataInput" (keyup)="applyFilter($event, 'actividad')" (focus)="setupFilter('actividad')" />
									</th>
								</ng-container>
								<ng-container matColumnDef="actividad">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminTableDescription" | translate }}</th>
									<td mat-cell *matCellDef="let row">{{ row.actividad }}</td>
								</ng-container>
								<ng-container matColumnDef="lectura">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminRead" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.lectura" [disabled]="!isEditMode" (checkedChange)="onRowLecturaChange(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionContrato">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditContrato" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Contrato" [disabled]="!isEditMode" (checkedChange)="onEditContratoChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionCentro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditCenter" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Centro" [disabled]="!isEditMode" (checkedChange)="onEditCenterChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="['filtro']; sticky: true"></tr>
								<tr mat-header-row *matHeaderRowDef="['actividad', 'lectura', 'edicionContrato', 'edicionCentro']; sticky: true"></tr>
								<tr mat-row *matRowDef="let row; columns: ['actividad', 'lectura', 'edicionContrato', 'edicionCentro']"></tr>
							</table>
						</div>
					</div>

					<!-- Contratos -->
					<div class="perm-panel" [hidden]="activeTab !== 1">
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsContrato">
								<ng-container matColumnDef="filtro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell" [attr.colspan]="4">
										<input type="text" [placeholder]="'admin.filter' | translate" class="dataInput" (keyup)="applyFilter($event, 'contrato')" (focus)="setupFilter('contrato')" />
									</th>
								</ng-container>
								<ng-container matColumnDef="contrato">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminTableDescription" | translate }}</th>
									<td mat-cell *matCellDef="let row">{{ row.contrato }}</td>
								</ng-container>
								<ng-container matColumnDef="lectura">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminRead" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.lectura" [disabled]="!isEditMode" (checkedChange)="onRowLecturaChange(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionContrato">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditContrato" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Contrato" [disabled]="!isEditMode" (checkedChange)="onEditContratoChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionCentro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditCenter" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Centro" [disabled]="!isEditMode" (checkedChange)="onEditCenterChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="['filtro']; sticky: true"></tr>
								<tr mat-header-row *matHeaderRowDef="['contrato', 'lectura', 'edicionContrato', 'edicionCentro']; sticky: true"></tr>
								<tr mat-row *matRowDef="let row; columns: ['contrato', 'lectura', 'edicionContrato', 'edicionCentro']"></tr>
							</table>
							<mat-paginator #pagContrato [pageSize]="25" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
						</div>
					</div>

					<!-- Organización de Supervisión (zona) -->
					<div class="perm-panel" [hidden]="activeTab !== 2">
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsZone">
								<ng-container matColumnDef="filtro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell" [attr.colspan]="4">
										<input type="text" [placeholder]="'admin.filter' | translate" class="dataInput" (keyup)="applyFilter($event, 'zonaSociedad')" (focus)="setupFilter('zonaSociedad')" />
									</th>
								</ng-container>
								<ng-container matColumnDef="zonaSociedad">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminTableDescription" | translate }}</th>
									<td mat-cell *matCellDef="let row">{{ row.zonaSociedad }}</td>
								</ng-container>
								<ng-container matColumnDef="lectura">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminRead" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.lectura" [disabled]="!isEditMode" (checkedChange)="onRowLecturaChange(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionContrato">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditContrato" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Contrato" [disabled]="!isEditMode" (checkedChange)="onEditContratoChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionCentro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditCenter" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Centro" [disabled]="!isEditMode" (checkedChange)="onEditCenterChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="['filtro']; sticky: true"></tr>
								<tr mat-header-row *matHeaderRowDef="['zonaSociedad', 'lectura', 'edicionContrato', 'edicionCentro']; sticky: true"></tr>
								<tr mat-row *matRowDef="let row; columns: ['zonaSociedad', 'lectura', 'edicionContrato', 'edicionCentro']"></tr>
							</table>
							<mat-paginator #pagZone [pageSize]="25" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
						</div>
					</div>

					<!-- Centros -->
					<div class="perm-panel" [hidden]="activeTab !== 3">
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsCenter">
								<ng-container matColumnDef="filtro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell" [attr.colspan]="4">
										<input type="text" [placeholder]="'admin.filter' | translate" class="dataInput" (keyup)="applyFilter($event, 'centro')" (focus)="setupFilter('centro')" />
									</th>
								</ng-container>
								<ng-container matColumnDef="centro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminTableDescription" | translate }}</th>
									<td mat-cell *matCellDef="let row">{{ row.centro }}</td>
								</ng-container>
								<ng-container matColumnDef="lectura">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminRead" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.lectura" [disabled]="!isEditMode" (checkedChange)="onRowLecturaChange(row)"></app-ds-toggle></td>
								</ng-container>
								<ng-container matColumnDef="edicionCentro">
									<th mat-header-cell *matHeaderCellDef class="mat-header-cell">{{ "admin.adminEditCenter" | translate }}</th>
									<td mat-cell *matCellDef="let row"><app-ds-toggle [checked]="row.edicion_Centro" [disabled]="!isEditMode" (checkedChange)="onEditCenterChangeRow(row)"></app-ds-toggle></td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="['filtro']; sticky: true"></tr>
								<tr mat-header-row *matHeaderRowDef="['centro', 'lectura', 'edicionCentro']; sticky: true"></tr>
								<tr mat-row *matRowDef="let row; columns: ['centro', 'lectura', 'edicionCentro']"></tr>
							</table>
							<mat-paginator #pagCenter [pageSize]="25" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>
